
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

interface ClientAvatarProps {
  firstName: string;
  lastName: string;
  avatarUrl?: string | null;
  colorCode?: string | null;
  onClick?: () => void;
}

const ClientAvatar = ({ 
  firstName, 
  lastName, 
  avatarUrl, 
  colorCode,
  onClick 
}: ClientAvatarProps) => {
  const firstInitial = firstName.length > 0 ? firstName[0] : '?';
  const lastInitial = lastName.length > 0 ? lastName[0] : '?';

  return (
    <Avatar 
      className="h-10 w-10 cursor-pointer" 
      onClick={onClick}
      style={{ 
        borderWidth: '2px', 
        borderStyle: 'solid',
        borderColor: colorCode || 'transparent' 
      }}
    >
      {avatarUrl ? (
        <AvatarImage src={avatarUrl} alt={firstName} />
      ) : (
        <AvatarFallback>{firstInitial}{lastInitial}</AvatarFallback>
      )}
    </Avatar>
  );
};

export default ClientAvatar;

